import { render, staticRenderFns } from "./EstoqueConfirmReceb.vue?vue&type=template&id=31706846&"
import script from "./EstoqueConfirmReceb.vue?vue&type=script&lang=js&"
export * from "./EstoqueConfirmReceb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports